export default "__VITE_ASSET__CWxRsAOh__"